/** My Work socket sync tab keys (must match API `MY_WORK_SYNC_TABS`). */
export const MY_WORK_SYNC_TABS = Object.freeze([
    'tasks',
    'my-submissions',
    'my-involvement',
    'my-informed',
    'notifications',
    'forms',
    'queue',
]);

export const MY_WORK_INVALIDATED_EVENT = 'my_work_invalidated';
